export enum VendorStatementTypes {
  purchase_invoice = "purchase_invoice",
  purchase_return = "purchase_return",
  transaction = "transaction",
}

/** Filter values used in the statement filter UI */
export enum VendorStatementFilter {
  ALL = "ALL",
  purchase = "purchase",
  transaction = "transaction",
}

/** Human-readable labels for each statement type */
export const STATEMENT_TYPE_LABELS: Record<VendorStatementTypes, string> = {
  [VendorStatementTypes.purchase_invoice]: "PURCHASE",
  [VendorStatementTypes.purchase_return]: "RETURN",
  [VendorStatementTypes.transaction]: "PAYMENT",
};

/** Colors for the purchase/amount column per statement type */
export const STATEMENT_PURCHASE_COLORS: Record<string, string> = {
  [VendorStatementTypes.purchase_invoice]: "red",
  [VendorStatementTypes.purchase_return]: "black",
};

/** The API types sent when "purchase" filter is selected */
export const PURCHASE_FILTER_TYPES = [VendorStatementTypes.purchase_invoice, VendorStatementTypes.purchase_return];

/** Statement types that belong to the purchase category */
export const isPurchaseType = (type: string): boolean =>
  type === VendorStatementTypes.purchase_invoice || type === VendorStatementTypes.purchase_return;

export const getStatementTypeLabel = (type: string): string => STATEMENT_TYPE_LABELS[type as VendorStatementTypes] ?? "-";

export interface IVendorStatementTableRow {
  sl: number;
  id: number;
  itemId: number;
  date: string;
  projectOrAccount: any;
  description: string;
  typeName: string;
  purchase: number;
  payment: number;
  balance?: number;
  type: VendorStatementTypes;
  meta: any;
}
